<script setup lang="ts">
const { data: books, status, error } = useBooks();
</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <!-- Header -->
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-gray-900 dark:text-white">
          Book Catalog
        </h1>
        <p class="mt-2 text-gray-600 dark:text-gray-400">
          Browse and read available books
        </p>
      </div>

      <!-- Loading state -->
      <div
        v-if="status === 'pending'"
        class="flex items-center justify-center py-12"
      >
        <UIcon
          name="i-heroicons-arrow-path"
          class="w-8 h-8 animate-spin text-primary-500"
        />
        <span class="ml-2 text-gray-600 dark:text-gray-400"
          >Loading books...</span
        >
      </div>

      <!-- Error state -->
      <UAlert
        v-else-if="error"
        color="error"
        icon="i-heroicons-exclamation-triangle"
        title="Error loading books"
        :description="error.message"
      />

      <!-- Empty state -->
      <div v-else-if="!books || books.length === 0" class="text-center py-12">
        <UIcon
          name="i-heroicons-book-open"
          class="w-16 h-16 mx-auto text-gray-400"
        />
        <h3 class="mt-4 text-lg font-medium text-gray-900 dark:text-white">
          No books found
        </h3>
        <p class="mt-2 text-gray-600 dark:text-gray-400">
          Add books to the data/books directory to get started.
        </p>
      </div>

      <!-- Book grid -->
      <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <CatalogBookCard v-for="book in books" :key="book.id" :book="book" />
      </div>
    </div>
  </div>
</template>
